﻿import { Injectable } from '@angular/core';
import { LoanApplicationOfferApi } from '../../../../../../generated/internalApi/api/LoanApplicationOfferApi';
import { Observable, throwError } from 'rxjs';
import {
  LDCommonWebApiResponseApiResponse,
  LDCLPBPPublicApiModelsLoanApplicationsOffersGetLoanApplicationOffersResponse,
  LDCLPBPPublicApiModelsLoanApplicationsOffersGetSelectedLoanApplicationOffersResponse,
  LDCLPBPPublicApiModelsLoanApplicationsOffersGenerateLoanApplicationOffersResponse,
  LDCLPBPPublicApiModelsLoanApplicationsOffersGenerateLoanApplicationOffersRequest,
  LDCLPBPPublicApiModelsLoanApplicationsSubmitPersonalLoanApplicationRequest,
  LDCLPBPPublicApiModelsLoanApplicationsTasksLoanApplicationTask as LoanAppTask
} from '../../../../../../generated/internalApi/model/models';
import {
  SubmitPersonalLoanApplicationRequest,
  SubmitPersonalLoanApplicationResponse
} from '../../../../shared/models/index';
import { OfferApi} from '../../../../../../generated/internalApi/api/OfferApi';
import { LoanApplicationApi } from '../../../../../../generated/internalApi/api/LoanApplicationApi';
import { LoanApplicationTaskApi } from '../../../../../../generated/internalApi/api/LoanApplicationTaskApi';
import { SessionService } from '../../../../shared/services/session/shared/session/session-service/session.service';
import { ApiService } from '../../../../shared/services/api.service';

@Injectable()
export class LoanOfferService extends ApiService {
  constructor(
    private loanApplicationOfferApi: LoanApplicationOfferApi,
    private loanApplicationTaskApi: LoanApplicationTaskApi,
    protected sessionService: SessionService,
    private offerApi: OfferApi,
    private loanApplicationApi: LoanApplicationApi) {

    super(sessionService);

    // Content-Type is not being set by default in the autogen classes, so setting it here.
    this.loanApplicationApi.defaultHeaders.set('Content-Type', 'application/json');
    this.loanApplicationOfferApi.defaultHeaders.set('Content-Type', 'application/json');
  }

  generateLoanApplicationOffers(newLoanAmount?: number
  ): Observable<LDCLPBPPublicApiModelsLoanApplicationsOffersGenerateLoanApplicationOffersResponse> {
    const plData = this.sessionService.personalLoanSession.data;
    let loanAmount = plData.loanAmount;
    if (newLoanAmount) {
      loanAmount = newLoanAmount;
    }
    const request = {
      loanAmount
    } as LDCLPBPPublicApiModelsLoanApplicationsOffersGenerateLoanApplicationOffersRequest;

    const loanApplicationGuid = plData.loanApplicationGuid;

    return this.loanApplicationOfferApi
      .loanApplicationOfferGenerateLoanApplicationOffers(
        loanApplicationGuid,
        request,
        this.authToken).map((response) => {

      return response.data;
    }).catch((err, caught) => {
      console.error(err);

      return throwError(err);
    });
  }

  getLoanApplicationOffers(
  ): Observable<LDCLPBPPublicApiModelsLoanApplicationsOffersGetLoanApplicationOffersResponse> {
    return this.loanApplicationOfferApi
      .loanApplicationOfferGetLoanApplicationOffers(
        this.sessionService.personalLoanSession.data.loanApplicationGuid,
        this.authToken).map(response => {

      return response.data;
    }).catch((err) => {

      console.error(err);
      return throwError(err);
    });
  }

  selectOffer(offerGuid: string): Observable<LDCommonWebApiResponseApiResponse> {
    let apiCall = this.offerApi.offerSelectLoanApplicationOffer(offerGuid, this.sessionService.data.authData.token);
    return apiCall.map(response => {
      return response;
    }).catch((err) => {
      console.error(err);
      return throwError(err);
    });
  }

  getSelectedOffers(): Observable<LDCLPBPPublicApiModelsLoanApplicationsOffersGetSelectedLoanApplicationOffersResponse> {
    let apiCall = this.loanApplicationOfferApi.loanApplicationOfferGetLoanSelectedApplicationOffer(
      this.sessionService.personalLoanSession.data.loanApplicationGuid,
      this.sessionService.data.authData.token);
    return apiCall.map(response => {
      return response.data;
    }).catch((err) => {
      console.error(err);
      return throwError(err);
    });
  }

  submitOffer(request: SubmitPersonalLoanApplicationRequest): Observable<SubmitPersonalLoanApplicationResponse> {
    const loanApplicationGuid = this.sessionService.personalLoanSession.data.loanApplicationGuid;
    const apiCall = this.loanApplicationApi.loanApplicationSubmitLoanApplication(
        loanApplicationGuid,
        request,
        this.authToken);
    return apiCall.map(response => {
      this.sessionService.personalLoanSession.data.loanSubmitted = true;
      return response.data;
    }).catch((err) => {
      if (err._body === '{"message":"Bad SSN"}') {
        this.sessionService.mismatchedSSN(true);
      };
      console.error(err);
      return throwError(err);
    });
  }

  /*** For future use ***/
  // The filtering on this can be used like:
  // let list = getLoanApplicationTasks(task => task.type === TypeEnum.UploadedDocument);
  getLoanApplicationTasks(filterPredicate?: (value: LoanAppTask, index: number, array: LoanAppTask[]) => any):
  Observable<Array<LoanAppTask>> {
    let apiCall = this.loanApplicationTaskApi.loanApplicationTaskGetLoanApplicationTasks(
      this.sessionService.personalLoanSession.data.loanApplicationGuid,
      this.authToken);
    return apiCall.map(response => {
      let data = response.data;
      let result = filterPredicate ? data.filter(filterPredicate) : data;
      return result;
    }).catch((err) => {
      console.error(err);
      return throwError(err);
    });
  }
}
